import SuccessCard from 'components/shared/SuccessCard/SuccessCard'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import ProjectSuggestions from 'components/Project/ProjectSuggestions/ProjectSuggestions'
import WhatsNextRecommendations from 'components/shared/WhatsNextCard/variants/WhatsNextRecommendations'
import WhatsNextProjectInPath from 'components/shared/WhatsNextCard/variants/WhatsNextProjectInPath'

export const CompletedProject = ({ project }) => {
  const { t } = useTranslation()

  const isLastProjectInPath =
    project.pathwayStep?.position === project.pathwayStep?.total

  const showWhatsNext =
    project.nextProject ||
    (project.recommendedPathways && project.recommendedPathways.length > 0)

  return (
    <>
      <HtmlHead
        title={`${project.title} | Complete`}
        image={project.heroImage}
      />
      <section className="c-project__content">
        <SuccessCard
          text={t('project.project_complete.congratulations', {
            title: project.title,
          })}
          subtext={t('project.project_complete.well_done')}
        >
          {showWhatsNext &&
            (isLastProjectInPath ? (
              <WhatsNextRecommendations
                recommendedPathways={project.recommendedPathways}
              />
            ) : (
              <WhatsNextProjectInPath
                currentPathwayName={project.included.pathways[0].title}
                currentPathwaySlug={project.included.pathways[0].slug}
                nextProject={project.nextProject.data.attributes}
              />
            ))}
        </SuccessCard>
        <ProjectSuggestions project={project} />
      </section>
    </>
  )
}

export default CompletedProject
CompletedProject.propTypes = {
  project: PropTypes.object.isRequired,
}
